import { sdk } from '@/services/sdk';

/**
 * Ghost Cable referral share card background (1080 x 1350): the ghost watching TV with the logo,
 * name and headline already on it. It comes through the referral-art function as a data URL,
 * because the file host sends no CORS header and the canvas that adds each buyer's link has to
 * stay exportable. Fetched once per page load, only on the referral pages.
 */
export const REFERRAL_ART_SIZE = { width: 1080, height: 1350 };

let pending = null;

function readValue(result) {
  if (!result?.ok) throw new Error(result?.error?.message || 'Could not load the card artwork.');
  let value = result.value;
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value);
    } catch {
      value = null;
    }
  }
  if (!value || value.success === false || typeof value.data !== 'string' || !value.data.startsWith('data:image/')) {
    throw new Error(value?.message || 'Could not load the card artwork.');
  }
  return value.data;
}

/** The artwork as a data URL. A failed load is not cached, so a retry asks again. */
export function loadReferralArt() {
  if (!pending) {
    const fn = import.meta.env.VITE_REFERRAL_ART;
    pending = (fn ? sdk.functions.invoke(fn, {}).then(readValue) : Promise.reject(new Error('The share picture is not set up yet.'))).catch(
      (e) => {
        pending = null;
        throw e;
      },
    );
  }
  return pending;
}
